import { Button, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { configs } from '@hero/configs';
import { ImagePreview } from '@hero/molecules';
import { getSafeInnerHtml, isHtmlEmpty } from '@hero/utils';

import * as S from './style';

function Inputs({ logoUrl, giftWrapperUrl, message, senderName }) {
  const { t } = useTranslation();

  return (
    <S.InputsWrapper src={giftWrapperUrl}>
      <S.PreviewWrapper>
        <S.CorporateIcons name="smartGiftRibbon" />
        <S.LogoWrapper>
          {logoUrl ? (
            <ImagePreview src={logoUrl} width={80} hasBorder={false} hasRadio={false} />
          ) : (
            <S.LogoPlaceholder>
              <Typography variant="body3SemiBold" color="fg">
                {t('logo')}
              </Typography>
            </S.LogoPlaceholder>
          )}
        </S.LogoWrapper>
        <S.SenderNameWrapper>
          <Typography variant="body5SemiBold" style={{ wordBreak: 'break-word' }}>
            {senderName || `(${t('yourNameHere')})`}
          </Typography>
        </S.SenderNameWrapper>
        <S.GiftMessageWrapper>
          {isHtmlEmpty(message) ? (
            <S.GiftMessageText>{t('yourGiftMessageHere').toLowerCase()}</S.GiftMessageText>
          ) : (
            <S.GiftMessageText {...getSafeInnerHtml(message)} />
          )}
        </S.GiftMessageWrapper>
        <S.ButtonsWrapper>
          <Button size="sm" color="secondary" block>
            <Typography variant="caption1ExtraBold" color="inherit">
              {t('unwrapMyGift')}
            </Typography>
          </Button>
          {configs?.general?.hasSkipUnwrap !== false && (
            <Button size="sm" variant="link" color="secondary">
              {t('skipUnwrap')}
            </Button>
          )}
        </S.ButtonsWrapper>
      </S.PreviewWrapper>
    </S.InputsWrapper>
  );
}

Inputs.propTypes = {
  logoUrl: PropTypes.string,
  giftWrapperUrl: PropTypes.string,
  message: PropTypes.object,
  senderName: PropTypes.string
};

export { Inputs };
